module.exports = __webpack_public_path__ + "img/asus-ux580.c4b9d586.jpg";